<template>
    <transition name="fade" >
        <component v-if="component" :is="component"></component>
    </transition>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
    computed: {
        is_open() {
            return this.$store.state.modals.is_open;
        },
        name() {
            return this.$store.state.modals.name;
        },
        component() {
            if(this.name) {
                return defineAsyncComponent(() =>
                    import(`./../components/modals/${this.name}`)
                )

            }
        }
    },
};
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        @apply transition-opacity duration-300 ease-out;
    }
    .fade-enter,
    .fade-leave-active {
        @apply opacity-0;
    }
</style>
